import React from 'react';
import Image from 'next/image';
import blogbaner from "../../public/images/blogbaner.jpg";

const Blogbaner = () => {
  return (
    <div className='relative w-[100%]'>
      <Image src={blogbaner} alt='campus placement automation' className='w-[100%] h-[125vh]' />
      <div className="page-title overflow-hidden text-center light-bg bg-contain animatedBackground  justify-center mt-24" data-bg-img="images/pattern/05.png">
        <div className='ml-20'>
          {/* <h4 className="text-[#FF5349] ml-3 my-2 text-left font-bold">#WeDriveEasyCampus</h4> */} <br/>
          <div className='text-xl font-bold text-[#FF5349] text-left'> #WeDriveEasyCampus</div><br /><br />
        </div>
        <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 lg:mt-12'>

          <h1><span className='text-amber-500'>Our </span> <span className='font-bold'>Blog</span></h1>
          <h2 className='font-bold mt-5'>Knowledge. Authority. Visibility</h2>
          <p className='py-2 text-[25px] font-extralight text-[#1e336a]'>We publish well-researched articles and blogs that provide<br/> significant value to all our stakeholders. These articles offer insights into the latest trends and<br/> updates, ensuring stakeholders stay informed and ahead of the curve</p>
        </div>
      </div>
    </div>
  )
}

export default Blogbaner